<template>
  <div id="app">
      <Loader :visible="loading"/>
      <router-view :class="{ 'loading': loading }" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "@/components/Loader";

export default {
  name: "app",
  components: {
    Loader
  },
  created() {
    this.$store.dispatch('popUpsHtml/getPopUps')
  },
  computed: {
    ...mapState("loader", ["loading"])
  },
  watch: {
          $route: {
              immediate: true,
              handler(to) {
                  document.title = to.meta.title || 'SharedCharter - Affordable Private Jet Travel';
              }
          },
      }
}

</script>
<style>

  .loading {
    filter: blur(4px) brightness(1.1);
  }
  .swal2-popup {
  font-size: 1.6rem !important;
  }

	body {
		background-color: #ffffff;
  }

  .date-picker.form-control[readonly],
  .date-picker-trips.form-control[readonly] {
    background-color:white;
  }

  @import './assets/css/bootstrap.css';
	@import './assets/css/main.css';
	/* @import './assets/js/jquery-3.3.1.min.js'; */
	/* @import './assets/js/jquery.main.js'; */
	/* @import 'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js'; */
	@import 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600;700&display=swap';
	/* @import 'https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js'; */
	/* @import 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.min.js'; */
	@import 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
	/* @import 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js'; */

</style>

